import React from "react";
import { Field } from "redux-form";
import { required, length } from "redux-form-validators";

import { scrollToTop } from "../../../../helpers/animation";
import { Button, InputOTP, Input } from "../../../../components/Field";
import ResendOTP from "./ResendOTP";
import Text from "../../../../components/Text";
import AsyncForm from "../../../../components/AsyncForm";

import style from "../style.module.css";

export default function Otp ({nextStep, personalDetails = {}}) {
    return (
        <div className={style.otpStep}>
            <AsyncForm
                url="/account/verify-otp"
                permission={false}
                showToastOnSuccess={false}
                initialValues={{
                    email: personalDetails.email
                }}
                onSave={() => {
                    nextStep('ConfirmDetails');
                    scrollToTop();
                }}
                render={({ fetching }) => {
                    return (
                        <div className={style.form}>
                            <div className={style.formRow}>
                                <Text className="formTitle" text="USER DETAILS" />
                            </div>
                            <div className={`${style.formRow} ${style.formRowHide}`}>
                                <Field 
                                    name="email" 
                                    component={Input} 
                                    validate={required()} 
                                    type="hidden" 
                                />
                            </div>
                            <div className={style.formRow}>
                                <Field 
                                    name="otp" 
                                    label="OTP"
                                    required={true} 
                                    component={InputOTP} 
                                    validate={[required(), length({ minimum: 6 })]} 
                                />
                            </div>
                            <div className={style.formRow}>
                                <ResendOTP email={personalDetails.email}/>
                            </div>
                            <div className={`${style.formRow} ${style.formSubmit}`}>
                                <Button
                                    submit={true}
                                    fetching={fetching}
                                    label="NEXT"
                                />
                            </div>
                        </div>
                    )
                }}
            />
        </div>
    )
}